import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Alert,
} from "reactstrap"
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import images from "../../assets/images"
import { AvForm, AvField } from "availity-reactstrap-validation"
//Import Breadcrumb
import Breadcrumbs from "../../components/Breadcrumb"
import {
  getDepartments,
  addDepartment,
  updateDepartment,
  deleteDepartment,
} from "../../store/departments/actions"

import PageLoader from "../../components/Loaders/pageLoader"

class DepartmentsList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      department: [],
      error: '',
      alert: null, 
      modal: false,
      DepartmentsListColumns: [
        {
          text: "id",
          dataField: "_id",
          sort: true,
          hidden: true,
          formatter: (cellContent, department) => <>{department._id}</>,
        },
        {
          dataField: "departmentPic",
          text: "#",
          formatter: (cellContent, department) => (
            <>
              {!department.departmentPic ? (
                <div className="avatar-xs">
                  <span className="avatar-title rounded-circle">
                    {department.depName.charAt(0)}
                  </span>
                </div>
              ) : (
                <div>
                  <img
                    className="rounded-circle avatar-xs"
                    src={images[department.departmentPic]}
                    alt=""
                  />
                </div>
              )}
            </>
          ),
        },
        {
          text: "Department",
          dataField: "depName",
          sort: true,
          formatter: (cellContent, department) => (
            <>
              <h5 className="font-size-16 mb-1">
                <Link to="#" className="text-dark">
                  {department.depName}
                </Link>
              </h5>
            </>
          ),
        },
        {
          dataField: "menu",
          isDummyField: true,
          editable: false,
          text: "Action",
          formatter: (cellContent, department) => (
            <div className="d-flex gap-3">
              <Link className="text-success" to="#">
                <i
                  className="mdi mdi-pencil font-size-18"
                  id="edittooltip"
                  onClick={() => this.handleDepartmentClickEdit(department)}
                ></i>
              </Link>
              <Link className="text-danger" to="#">
                <i
                  className="mdi mdi-delete font-size-18"
                  id="deletetooltip"
                  onClick={() => this.handleDeleteDepartment(department)}
                ></i>
              </Link>
            </div>
          ),
        },
      ],
    }
    //create/edit department functions
    this.handleDepartmentClickNew = this.handleDepartmentClickNew.bind(this)
    this.handleDepartmentClickEdit = this.handleDepartmentClickEdit.bind(this)
    this.checkExistingDepartment = this.checkExistingDepartment.bind(this)
    this.handleValidDepartmentSubmit = this.handleValidDepartmentSubmit.bind(this)

    this.toggle = this.toggle.bind(this)
    this.hideAlert = this.hideAlert.bind(this)

    this.getScreenHeight = this.getScreenHeight.bind(this)
  }
  componentDidMount() {
    const { onGetDepartments } = this.props
    onGetDepartments()
    window.addEventListener("load", this.getScreenHeight)
    window.addEventListener("resize", this.getScreenHeight)
  }
  componentWillUnmount() {
    window.removeEventListener("load", this.getScreenHeight)
    window.removeEventListener("resize", this.getScreenHeight)
  }
  /**
   * Get screen height of the table
   * @param {*} click 
   */
  getScreenHeight = click => {
    if(document.getElementById("card-section")){
      let screenHeight = document.getElementById("card-section").offsetHeight
      document
        .querySelector(".react-bootstrap-table")
        .setAttribute(
          "style",
          "height: calc(" + screenHeight + "px - 74px); overflow: auto;"
        )
    }
  }
  /**
   * Close/open modal window for creating/editing department name
   */
  toggle = () => this.setState(prevState => ({ modal: !prevState.modal }))
  /**
   * Open modal for creating new department
   */
  handleDepartmentClickNew = () => {
    this.setState({ department: [], error: "", isEdit: false })
    this.toggle()
  }
  /**
   * Assign data from table to selected department for edit
   * @param {array} department selected depratment info
   */
  handleDepartmentClickEdit = department => {
    this.setState({
      department: {
        _id: department._id,
        depName: department.depName,
      },
      isEdit: true,
      error: ""
    })
    this.toggle()
  }
  /**
   * Check if department is already exists in the table
   * @param {array} newDepartment value with new department name
   * @returns true or false
   */
  checkExistingDepartment = (newDepartment) => {
    const { departments } = this.props
    return departments.some(function(el) {
      return el.depName === newDepartment.depName;
    });
  }
  /**
   * Submit form data to backend
   * @param {*} e 
   * @param {array} values 
   */
  handleValidDepartmentSubmit = (e, values) => {
    const { onAddDepartment, onUpdateDepartment } = this.props
    const { isEdit, department } = this.state
    if (isEdit) {
      const updateDepartment = {
        _id: department._id,
        option: 'dep',
        depName: values.depName,
      }
      // update department
      if(this.checkExistingDepartment(updateDepartment) === true) {
        this.setState({ error: "Department already exists." })
      }else{
        onUpdateDepartment(updateDepartment)
        this.setState({ error: "" })
        this.toggle()
      }
    } else {
      const newDepartment = {
        option: 'dep',
        depName: values["depName"],
      }
      // add new department
      if(this.checkExistingDepartment(newDepartment) === true) {
        this.setState({ error: "Department already exists." })
      }else{
        onAddDepartment(newDepartment)
        this.setState({ error: "" })
        this.toggle()
      }
    }
  }
  /**
   * Call alert before delete
   * @param {array} department 
   */
  handleDeleteDepartment = department => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText="Yes, delete it!"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => this.deleteAlert(department._id+'&dep')}
        onCancel={this.hideAlert}
        focusCancelBtn
      >
        <p className="fw-bold">{department.depName}</p> will be deleted from the system!
      </SweetAlert>
    )
    this.setState({ alert: getAlert() })
  }
  /**
   * @returns set state of alert to null
   */
  hideAlert = () => this.setState({ alert: null })
  /**
   * Delete department from database
   * @param {array} department 
   */
  deleteAlert(id) {
    const { onDeleteDepartment } = this.props
    onDeleteDepartment(id)
    this.setState({
      alert: null,
    })
  }

  render() {
    const { SearchBar } = Search
    const { departments, profileData } = this.props
    const { isEdit, error, department, modal, alert, loading, DepartmentsListColumns } = this.state
    const pageOptions = {
      sizePerPage: departments.length,
      totalSize: departments.length, // replace later with size(users),
      custom: true,
    }
    const defaultSorted = [
      {
        dataField: "_id", // if dataField is not match to any column you defined, it will be ignored.
        order: "asc", // desc or asc
      },
    ]
    const selectRow = {
      mode: "checkbox",
    }
    return (
      <React.Fragment>
        {/* {profileData.length === 0 && loading && <PageLoader />} */}
        {profileData.length !== 0 && <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>}
        <div className="page-content">
          <MetaTags>
            <title>Department List </title>
          </MetaTags>
          <Container fluid>
            {profileData.accType === "Admin" ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title="Admin" breadcrumbItem="Department List" />
                <Row id="card-section">
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="_id"
                          columns={DepartmentsListColumns}
                          data={departments}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="_id"
                              columns={DepartmentsListColumns}
                              data={departments}
                              search
                            >
                              {toolkitprops => (
                                <React.Fragment>
                                  <Row className="mb-2">
                                    <Col sm="4">
                                      <div className="search-box ms-2 mb-2 d-inline-block">
                                        <div className="position-relative">
                                          <SearchBar
                                            {...toolkitprops.searchProps}
                                          />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col sm="8">
                                      <div className="text-sm-end">
                                        <Button
                                          color="primary"
                                          className="font-16 btn-block btn btn-primary btn-lg"
                                          onClick={this.handleDepartmentClickNew}
                                        >
                                          <i className="mdi mdi-plus-circle-outline me-1" />
                                          Create New Department
                                        </Button>
                                        <Modal
                                          size="sm"
                                          isOpen={modal}
                                          className={this.props.className}
                                          toggle={this.toggle}
                                        >
                                          <ModalHeader
                                            toggle={this.toggle}
                                            tag="h4"
                                          >
                                            {!!isEdit
                                              ? "Edit Department"
                                              : "Add Department"}
                                          </ModalHeader>
                                          <ModalBody>
                                            {error !== '' &&
                                            error ? (
                                              <Alert color="danger">
                                                {" "}
                                                {error}{" "}
                                              </Alert>
                                            ) : null}
                                            <AvForm
                                              onValidSubmit={
                                                this.handleValidDepartmentSubmit
                                              }
                                            >
                                              <Row>
                                                <Col md={12}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="depName"
                                                      label="Department"
                                                      type="text"
                                                      errorMessage="Invalid name"
                                                      validate={{
                                                        required: {
                                                          value: true,
                                                        },
                                                      }}
                                                      value={
                                                        department.depName || ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>

                                              <Row>
                                                <Col>
                                                  <div className="text-end">
                                                    <button
                                                      type="submit"
                                                      className="btn btn-success save-user"
                                                    >
                                                      {!!isEdit
                                                        ? "Edit Department"
                                                        : "Add Department"}
                                                    </button>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </AvForm>
                                          </ModalBody>
                                        </Modal>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xl="12">
                                      <div className="table-responsive">
                                        <BootstrapTable
                                          {...toolkitprops.baseProps}
                                          {...paginationTableProps}
                                          selectRow={selectRow}
                                          defaultSorted={defaultSorted}
                                          classes={
                                            "table align-middle table-nowrap table-hover"
                                          }
                                          headerClasses="header-class is-sticky-hdr"
                                          id="tableScroll"
                                          bordered={true}
                                          // striped={true}
                                          responsive
                                        />
                                        {alert}
                                      </div>
                                    </Col>
                                  </Row>
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color="danger">
                {" "}
                You do not have access to this page.{" "}
              </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

DepartmentsList.propTypes = {
  departments: PropTypes.array,
  onGetDepartments: PropTypes.func,
  onAddDepartment: PropTypes.func,
  onDeleteDepartment: PropTypes.func,
  onUpdateDepartment: PropTypes.func,
}

const mapStateToProps = ({ departments }) => ({
  departments: departments.departments,
  loading: departments.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetDepartments: () => dispatch(getDepartments()),
  onAddDepartment: department => dispatch(addDepartment(department)),
  onUpdateDepartment: department => dispatch(updateDepartment(department)),
  onDeleteDepartment: department => dispatch(deleteDepartment(department)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DepartmentsList))
